import type { CSSInterpolation } from '@emotion/serialize';
import type { ForwardedRef } from 'react';
import { forwardRef } from 'react';

import IconAddFilled from '~icons/carbon/add-filled';

import { su, theme, typography } from '@adflow/frontend/ui-theme';

import type { ButtonIconAddProps } from './ButtonIconAdd';
import { buttonIconAddStyles } from './ButtonIconAdd';

export type ButtonIconAddWithTextProps = ButtonIconAddProps & {
	// Does the text appear to the left or right of the add icon
	side?: 'left' | 'right';
	text: string;
	buttonStyle?: CSSInterpolation;
	small?: boolean;
};

export const ButtonIconAddWithText = forwardRef(
	function ButtonIconAddWithTextRender(
		props: ButtonIconAddWithTextProps,
		ref: ForwardedRef<HTMLButtonElement>
	) {
		const {
			side = 'left',
			text,
			buttonStyle,
			small = false,
			...buttonProps
		} = props;
		return (
			<button
				data-testid="button-add"
				type="button"
				{...buttonProps}
				css={[
					typography.clickableLink,
					su.textMd,
					{
						color: theme.colors.text.tableHeader,
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						cursor: 'pointer',
						'&:disabled, &[data-disabled=true]': {
							color: theme.colors.text.hint,
							cursor: 'default',
							'& [data-icon]': {
								color: theme.colors.action.disabledBackground,
							},
						},
					},
					buttonStyle,
				]}
				ref={ref}
			>
				{side === 'left' ? text : null}
				<IconAddFilled
					data-icon
					css={[
						buttonIconAddStyles.icon,
						{ width: '1.25rem', height: '1.25rem' },
						side === 'left'
							? { marginLeft: '0.5rem' }
							: { marginRight: '0.5rem' },
						small && { width: 18, height: 18 },
					]}
				/>

				{side === 'right' ? text : null}
			</button>
		);
	}
);
